import { fromJS } from 'immutable';
import { SET_CONTEXT_UUID, SET_OUTCOMES_ENDPOINT, SET_OUTCOMES_TOKEN, SET_EXTERNAL_ACCOUNT_UUID } from '@instructure/quiz-common';
var defaultState = fromJS({
  contextUuid: '',
  outcomesEndpoint: '',
  outcomesToken: '',
  externalAccountUuid: ''
});
export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case SET_CONTEXT_UUID:
      return state.set('contextUuid', action.payload);
    case SET_OUTCOMES_ENDPOINT:
      return state.set('outcomesEndpoint', action.payload);
    case SET_OUTCOMES_TOKEN:
      return state.set('outcomesToken', action.payload);
    case SET_EXTERNAL_ACCOUNT_UUID:
      return state.set('externalAccountUuid', action.payload);
    default:
      return state;
  }
});